<template id="carousel">
  <swiper class="swiper" :options="swiperOption">
    <swiper-slide v-for="(anuncio, index) in anuncios" :key="index">
      <a :href="baseLinkWhatsapp + anuncio.nome">
        <img
          :src="anuncio.imagem"
          :alt="`anuncio-${anuncio.nome}`"
          class="image-style"
        />
      </a>
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
    <div class="swiper-button-prev" slot="button-prev"></div>
    <div class="swiper-button-next" slot="button-next"></div>
  </swiper>
</template>
<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  props: {
    anuncios: Array
  },
  data() {
    return {
      baseLinkWhatsapp:
        'https://wa.me/5581995212354?text=Oi%2c+tenho+interesse+no+item+',
      swiperOption: {
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        slidesPerView: 5,
        spaceBetween: 50,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          1024: {
            slidesPerView: 5,
            spaceBetween: 30
          },
          900: {
            slidesPerView: 4,
            spaceBetween: 30
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 10
          }
        }
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.image-style {
  width: 100%;
  height: 100%;
}
</style>
